import clsx from "clsx";

interface TileProps {
  key: string;
  text: string;
}

type OnClick = (clickedKey: string, clickedIndex: number) => void;

interface Props {
  elements: TileProps[];
  emptyMessage: string;
  //TODO: onClick and onClickRemove e.g. can be per-element
  onClick?: OnClick;
  onClickRemove?: OnClick;
}

//TODO: this originally copied from InterestingWords - some DRY could be done here
const Tiles: React.FC<Props> = ({
  elements,
  emptyMessage,
  onClick: onClickProp,
  onClickRemove: onClickRemoveProp,
}) => {
  if (elements.length === 0) {
    return <div>{emptyMessage}</div>;
  }

  let onClick: OnClick | undefined;
  let onClickRemove: OnClick | undefined;
  if (onClickProp && onClickRemoveProp) {
    onClick = onClickProp;
    onClickRemove = onClickRemoveProp;
  } else if (onClickRemoveProp) {
    onClick = onClickRemoveProp;
    onClickRemove = onClickRemoveProp;
  } else if (onClickProp) {
    onClick = onClickProp;
  }

  return (
    <div className="flex gap-2">
      {elements.map((element, elementIndex) => (
        <div key={element.key} className="bg-gray-100">
          <button
            className={clsx("hover:pointer hover:bg-gray-200")}
            onClick={() => {
              if (onClick) {
                onClick(element.key, elementIndex);
              }
            }}
          >
            <div className="w-1/8 py-1 px-2 text-left active:text-purple-600">
              {element.text}
              {onClickRemove && (
                <span
                  className="pl-2 cursor:pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onClickRemove) {
                      onClickRemove(element.key, elementIndex);
                    }
                  }}
                >
                  x
                </span>
              )}
            </div>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Tiles;
